module.exports = "/layout/app/images/logo.97514d15.svg";